import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "df df-around" }
const _hoisted_2 = ["src"]

import { reactive, watch, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'preview',
  props: {
    value: { default: '' }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const visible = ref(false);

const list = reactive([]);

const compatible = () => {
    list.length = 0;

    if (!props.value) return;

    if (props.value.indexOf('[') !== -1 && props.value.indexOf(']') !== -1) {
        list.push(...JSON.parse(props.value));
        return;
    }

    list.push(...props.value.split(','));
};

compatible();

watch(() => props.value, (val) => {
    compatible()
}, {
    deep: true
})

__expose({
    compatible
});


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_button, {
      size: "small",
      onClick: _cache[0] || (_cache[0] = () => visible.value = true)
    }, {
      default: _withCtx(() => [
        _createTextVNode("视频预览")
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      title: "视频预览",
      width: "800px",
      destroyOnClose: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (url) => {
            return (_openBlock(), _createElementBlock("video", {
              src: url,
              key: url,
              controls: "",
              width: "200"
            }, null, 8, _hoisted_2))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})